import { useState, useRef } from 'react';
import './Accordion.css';

const Accordion = ({ sections, defaultOpen = [] }) => {
  const [openSections, setOpenSections] = useState(() => [...defaultOpen]);
  const accordionRef = useRef(null);
  const sectionRefs = useRef({});
  const contentRefs = useRef({});

  const toggleSection = (index) => {
    const contentEl = contentRefs.current[index];
    
    if (!contentEl) return;
    
    const isOpen = openSections.includes(index);
    
    if (isOpen) {
      // Close section with jQuery-like slideUp
      contentEl.style.height = contentEl.scrollHeight + 'px';
      setTimeout(() => {
        contentEl.style.height = '0px';
        contentEl.style.opacity = '0';
      }, 10);
      setTimeout(() => {
        contentEl.style.display = 'none';
      }, 600);
      
      setOpenSections(openSections.filter(i => i !== index));
    } else {
      // Open section with jQuery-like slideDown
      contentEl.style.display = 'block';
      contentEl.style.height = '0px';
      contentEl.style.opacity = '0';
      
      setTimeout(() => {
        contentEl.style.height = contentEl.scrollHeight + 'px';
        contentEl.style.opacity = '1';
      }, 10);
      
      setTimeout(() => {
        contentEl.style.height = 'auto';
      }, 600);
      
      setOpenSections([...openSections, index]);
      
      // Slide-to-top scroll
      setTimeout(() => {
        const sectionElement = sectionRefs.current[index];
        if (sectionElement) {
          const offsetTop = sectionElement.offsetTop;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  };

  return (
    <div className="wrapper">
      <div className="st-accordion" ref={accordionRef}>
        <ul>
          {sections.map((section, index) => {
            const isOpen = openSections.includes(index);
            return (
              <li
                key={index}
                className={isOpen ? 'st-open' : ''}
                ref={(el) => sectionRefs.current[index] = el}
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleSection(index);
                  }}
                >
                  {section.title}
                  <span className="st-arrow">Open or Close</span>
                </a>
                <div
                  className="st-content"
                  ref={(el) => contentRefs.current[index] = el}
                  style={{
                    display: isOpen ? 'block' : 'none',
                    height: isOpen ? 'auto' : '0px',
                    opacity: isOpen ? 1 : 0,
                    overflow: 'hidden',
                    transition: 'height 0.6s ease-in-out, opacity 0.6s ease-in-out'
                  }}
                >
                  {section.content}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Accordion;
